import React, { useState } from 'react';
import { Box, Typography, Button, Collapse, useTheme, List, ListItem, ListItemText, Grid, Link } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import eDevletInfo from '../../assets/images/relative-join-form/e-devlet-info.webp';
import ReactPlayer from 'react-player';

const DetailedInfo: React.FC = () => {
    const [expanded, setExpanded] = useState(false);
    const theme = useTheme();

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <Box
            sx={{
                backgroundColor: '#FBEFE3',
                padding: theme.spacing(2),
                borderRadius: '4px',
                marginY: theme.spacing(2),
            }}>
            <Typography variant="body1" color="#945F2F" paddingLeft="8px" fontWeight={theme.typography.fontWeightBold} gutterBottom>
                Nüfus Kayıt Örneği (Nüfus Aile Tipi seçilmesi zorunludur) belgesine nasıl ulaşırım?
            </Typography>
            <Box display="flex" justifyContent="center" marginBottom={2} marginTop={2} sx={{ width: '90%', mx: 'auto', aspectRatio: '16/9' }}>
                <ReactPlayer src='https://www.youtube.com/shorts/-cwL5y5g3Rg' width="100%" height="100%" controls={true} config={{ youtube: { rel: 0, color: "white" } }} />
            </Box>
            <List sx={{ paddingLeft: 0 }}>
                {[1, 2, 3, 4].map(num => (
                    <ListItem key={num} sx={{ display: 'flex', alignItems: 'flex-start', padding: 0 }}>
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: '2rem',
                                fontWeight: 'bold',
                                color: '#E49248',
                                fontSize: '1.2rem',
                                textAlign: 'center',
                                lineHeight: '1.7',
                            }}>
                            {num}.
                        </Box>
                        <ListItemText
                            primary={
                                <Box
                                    sx={{
                                        color: '#945F2F',
                                        marginLeft: theme.spacing(1),
                                        lineHeight: '1.5',
                                    }}>
                                    {num === 1 && (
                                        <>
                                            E-devlet'e giriş yapılarak arama kısmına <strong>"Nüfus Kayıt Örneği Belgesi Sorgulama"</strong> yaz. Ulaşmak için <Link href="https://turkiye.gov.tr/nvi-nufus-kayit-ornegi-belgesi-sorgulama" color="inherit">tıkla.</Link>
                                        </>
                                    )}
                                    {num === 2 && (
                                        <>
                                            Açılan ekranda onayları ver.
                                            <br/>Belge Tipi: <strong>Nüfus Aile</strong>
                                            <br/>Eski Eş Listele: <strong>Evet</strong>
                                            <br/>Vukuatlı Belge: <strong>Evet</strong>
                                            <br/>Belge Nedeni: <strong>Kişi Talebi</strong>
                                            <br/>
                                            <br/><strong>Not</strong>: Medeni hali evli olan kadınlarda, soyadı değişikliği nedeniyle sistem iki farklı aile kaydı gösterebilir. Bu durumda, davet oluşturmak istediğiniz aile üyeliğine uygun olan kaydı seçmeniz yeterlidir.
                                        </>
                                    )}
                                    {num === 3 && (
                                        <>
                                            Sağ üstte yer alan <strong>"Dosyayı İndir"</strong> diyerek PDF belgesini kaydet.
                                        </>
                                    )}
                                    {num === 4 && (
                                        <>
                                            Son olarak E-Devlet'ten aldığın dosyayı aşağıdaki alana yükle.
                                            <br/><br/><strong>Nüfus Aile Kayıt Örneği,</strong> kendisi, eşi, çocukları ve varsa eski eş/eşlerine (isteğe bağlı) ait bilgileri içeren kayıtlardan oluşmaktadır.
                                        </>
                                    )}
                                </Box>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default DetailedInfo;
